import * as React from 'react';
import s from './TinyLink.scss';
import { TextButton } from '@wix/design-system';

export interface TinyLinkProps {
  link: string;
}
export const TinyLink: React.FunctionComponent<TinyLinkProps> = ({
  link,
  children,
}) => (
  <TextButton as='a' href={link} target='_blank' className={s.tinyLink}>
    <div className={s.tinyText}>{children}</div>
  </TextButton>
);
